import React from "react";
import "./Spinner.css";

const Spinner = ({ size = "medium", className = "" }) => {
  return (
    <div className={`spinner-wrapper ${className}`}>
      <div className={`spinner-ring ${size}`}></div>
    </div>
  );
};

export default Spinner;
